import React from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import MainLayout from './components/client/MainLayout';
import Home from './components/client/Home';
import Menu from './components/client/Menu';
import Cart from './components/client/Cart';
import Payment from './components/client/Payment';
import WaiterPanel from './components/waiter/WaiterPanel';
import SuccessPayment from './components/SuccessPayment';
import WebSocketWrapper from './components/client/WebSocketWrapper';
import RestaurantMain from "./components/restaurant/RestaurantMain";
import RescanQR from "./components/client/RescanQR";
import AdminMain from "./components/admin/AdminMain";
import CompleteRegistration from "./components/admin/CompleteRegistration";
import ContactPage from "./components/client/ContactPage";

const App = () => (
    <Router>
        <Routes>
            <Route path="/contact" element={<ContactPage />} />

            <Route element={<WebSocketWrapper><MainLayout /></WebSocketWrapper>}>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/success" element={<SuccessPayment />} />
            </Route>
            <Route path="/rescan" element={<RescanQR />} />

            {/* Ścieżka dla WaiterPanel bez WebSocketWrapper */}
            <Route path="/waiterPanel" element={<WaiterPanel />} />
            <Route path="/restaurantPanel" element={<RestaurantMain />} />
            <Route path="/adminPanel" element={<AdminMain />} />
            <Route path="/complete-registration" element={<CompleteRegistration />} />
        </Routes>
    </Router>
);

export default App;